import React, { useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import { Button, Card, Row, Col, Form, OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import supplierService from "../../services/master/SupplierService.js";
import { FaEdit, FaPlus, FaMinus } from "react-icons/fa";

const SupplierPage = () => {
  const navigate = useNavigate();
  const [upiList, setUpiList] = useState([]);
  const [expandedUpiId, setExpandedUpiId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  // Fetch UPI
useEffect(() => {
  const fetchUpi = async () => {
    try {
      setLoading(true);
      const upiData = await supplierService.getUpiHaccp(currentPage, perPage, searchKeyword);

      if (upiData && upiData.data) {
        setUpiList(upiData.data);
        setTotalRows(upiData.totalRows); // sesuai controller
      }
    } catch (err) {
      console.error("Gagal ambil data UPI:", err);
      setUpiList([]);
    } finally {
      setLoading(false);
    }
  };
  fetchUpi();
}, [currentPage, perPage, searchKeyword]);


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handler untuk mengubah jumlah data per halaman
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };


const handleEdit = (data) => {
  const payload = {
    id_haccp: data.id_haccp,
    no_haccp: data.no_haccp,
    UPI_ID: data.UPI_ID,        // pastikan ada di hasil query
    UPI_REG_ID: data.UPI_REG_ID // pastikan ada di hasil query
  };

  localStorage.setItem("editSupplierData", JSON.stringify(payload));
  navigate("/setting/edit-supplier");
};



  const handleReset = () => {
    setSearchKeyword("");
  };

  // Kolom tabel utama
const columnsUpi = [
  // { 
  //   name: "ID UPI", 
  //   selector: (row) => row.UPI_ID || row.id, 
  //   wrap: true 
  // },
  { 
    name: "Nama UPI", 
    selector: (row) => row.nama_upi || "-",
    wrap: true 
  },
  { 
    name: "Alamat", 
    selector: (row) => row.UPI_ALAMAT || "-",
    wrap: true 
  },
  { 
    name: "No HACCP", 
    selector: (row) => row.no_haccp || "-",
    wrap: true 
  },
  { 
    name: "Jenis Produk", 
    selector: (row) => row.komoditas || "-",
    wrap: true 
  },
  { 
    name: "Status", 
    selector: (row) => row.status_sert || "-",
    wrap: true 
  },
    {
      name: "Action",
      width: "100px",
      cell: (row) => (
        <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit Data Supplier</Tooltip>}>
          <Button
            size="sm"
            variant="warning"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(row);
            }}
          >
            <FaEdit />
          </Button>
        </OverlayTrigger>
      ),
    },
  ];

  // Expanded UPI > Supplier
const ExpandedUpi = ({ data }) => {
  const [loadingSup, setLoadingSup] = useState(false);
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    const fetchSuppliers = async () => {
      setLoadingSup(true);
      try {
        const supData = await supplierService.getSupplierWithRegisterById(data.id_haccp);
        //console.log("Data Supplier:", supData);
        const supplierArray = Array.isArray(supData) ? supData : [supData];
        setSuppliers(supplierArray);
      } catch (error) {
        console.error("Gagal ambil supplier:", error);
        setSuppliers([]); 
      } finally {
        setLoadingSup(false);
      }
    };

    
    if (data.id_haccp) {
      fetchSuppliers();
    }
  }, [data.UPI_REG_ID]);

  const columnsSup = [
    { name: "Nama Supplier", selector: (row) => row.nama_supp || "-", wrap: true },
    { name: "Nomor", selector: (row) => row.no_supp || "-", wrap: true },
    { name: "Jenis Produk", selector: (row) => row.jenis_produk || "-", wrap: true },
  ];

  return (
    <Card className="shadow-sm p-2">
      <Card.Body>
        <h6>Supplier untuk UPI: {data.nama_upi}</h6>
        <DataTable
          columns={columnsSup}
          data={suppliers}
          noHeader
          dense
          progressPending={loadingSup}
          progressComponent={<Spinner animation="border" size="sm" />}
          noDataComponent="Tidak ada data supplier"
          customStyles={{
            headCells: {
              style: {
                backgroundColor: "#fc8c4bff",
                color: "#000",
                fontWeight: "600",
                paddingLeft: "20px",
              },
            },
            cells: {
              style: {
                paddingLeft: "20px",
              },
            },
          }}
        />
      </Card.Body>
    </Card>
  );
};

  return (
    <Row>
      <Col sm="12">
        {/* Pencarian */}
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Pencarian Data</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="align-items-end">
                <Col sm="3">
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Cari disini..."
                      value={searchKeyword}
                      onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col sm="2">
                  <Button variant="secondary" className="w-100" onClick={handleReset}>
                    Reset
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Tabel Data UPI */}
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h2 className="card-title">Data Supplier</h2>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive border-bottom my-3">
              <DataTable
                columns={columnsUpi}
                data={upiList}
                pagination
                paginationServer
                paginationTotalRows={totalRows} 
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                expandableRows
                expandableRowExpanded={(row) => expandedUpiId === String(row.UPI_ID)}
                // onRowClicked={(row) =>
                //   setExpandedUpiId(
                //     expandedUpiId === String(row.UPI_ID) ? null : String(row.UPI_ID)
                //   )
                // }
                progressPending={loading}
                progressComponent={
                  <div className="text-center my-3">
                    <Spinner animation="border" /> Loading data...
                  </div>
                }
                noDataComponent="Tidak ada data UPI"
                expandableIcon={{
                  collapsed: <FaPlus size={12} color="blue" />,
                  expanded: <FaMinus size={12} color="red" />,
                }}
                expandableRowsComponent={ExpandedUpi}
                 customStyles={{
                        headCells: {
                          style: {
                            backgroundColor: "#00acee",
                            color: "white",
                          },
                        },
                        cells: {
                          style: {
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            fontSize: '14px',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '20px',
                          },
                        },
                      }}
              />

            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SupplierPage;
